import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["name", "address", "city", "state", "zip"];
  static values = { name: String, address: String, city: String, state: String, zip: String };

  fillFromOrganization(event) {
    event.preventDefault();
    this.nameTarget.value = this.nameValue;
    this.addressTarget.value = this.addressValue;
    this.cityTarget.value = this.cityValue;
    this.stateTarget.value = this.stateValue;
    this.zipTarget.value = this.zipValue;
  }
}
